<template>
  <footer class="footer">
    <img src="../assets/img/buro.webp" alt="Buró">
    <div class="footer-text">© 2025 SIHUSEL Servicios Financieros SIHUSEL S.A.P.I. de C.V. Av. Acueducto 2052 Int. 38-B, Colinas de San Javier, Guadalajara, Jalisco CP. 44660, México.</div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSihusel'
}
</script>

